export default {
  "ext": "ext.",
  "country": "País",
  "phone": "Telefone",
  "AB": "Abecásia",
  "AC": "Ilha de Ascensão",
  "AD": "Andora",
  "AE": "Emirados Árabes Unidos",
  "AF": "Afeganistão",
  "AG": "Antígua e Barbuda",
  "AI": "Anguilla",
  "AL": "Albânia",
  "AM": "Arménia",
  "AO": "Angola",
  "AQ": "Antártida",
  "AR": "Argentina",
  "AS": "Samoa Americana",
  "AT": "Áustria",
  "AU": "Austrália",
  "AW": "Aruba",
  "AX": "Ilhas de Aland",
  "AZ": "Azerbaijão",
  "BA": "Bósnia e Herzegovina",
  "BB": "Barbados",
  "BD": "Bangladesh",
  "BE": "Bélgica",
  "BF": "Burkina Faso",
  "BG": "Bulgária",
  "BH": "Bahrein",
  "BI": "Burundi",
  "BJ": "Benim",
  "BL": "São Bartolomeu",
  "BM": "Bermudas",
  "BN": "Brunei",
  "BO": "Bolívia",
  "BQ": "Países Baixos Caribenhos",
  "BR": "Brasil",
  "BS": "Bahamas",
  "BT": "Butão",
  "BV": "Ilha Bouvet",
  "BW": "Botswana",
  "BY": "Bielorrússia",
  "BZ": "Belize",
  "CA": "Canadá",
  "CC": "Ilhas Cocos (Keeling)",
  "CD": "Congo, República Democrática do",
  "CF": "República Centro-Africana",
  "CG": "Congo",
  "CH": "Suíça",
  "CI": "Costa do Marfim",
  "CK": "Ilhas Cook",
  "CL": "Chile",
  "CM": "Camarões",
  "CN": "China",
  "CO": "Colômbia",
  "CR": "Costa Rica",
  "CU": "Cuba",
  "CV": "Cabo Verde",
  "CW": "Curaçao",
  "CX": "Ilha Christmas",
  "CY": "Chipre",
  "CZ": "República Checa",
  "DE": "Alemanha",
  "DJ": "Djibouti",
  "DK": "Dinamarca",
  "DM": "Dominica",
  "DO": "República Dominicana",
  "DZ": "Argélia",
  "EC": "Equador",
  "EE": "Estónia",
  "EG": "Egito",
  "EH": "Saara Ocidental",
  "ER": "Eritreia",
  "ES": "Espanha",
  "ET": "Etiópia",
  "FI": "Finlândia",
  "FJ": "Fiji",
  "FK": "Ilhas Malvinas",
  "FM": "Micronésia",
  "FO": "Ilhas Faroé",
  "FR": "França",
  "GA": "Gabão",
  "GB": "Reino Unido",
  "GD": "Granada",
  "GE": "Geórgia",
  "GF": "Guiana Francesa",
  "GG": "Guernsey",
  "GH": "Gana",
  "GI": "Gibraltar",
  "GL": "Groenlândia",
  "GM": "Gâmbia",
  "GN": "Guiné",
  "GP": "Guadalupe",
  "GQ": "Guiné Equatorial",
  "GR": "Grécia",
  "GS": "Ilhas Geórgia do Sul e Sandwich do Sul",
  "GT": "Guatemala",
  "GU": "Guam",
  "GW": "Guiné-Bissau",
  "GY": "Guiana",
  "HK": "Hong Kong",
  "HM": "Ilha Heard e Ilhas McDonald",
  "HN": "Honduras",
  "HR": "Croácia",
  "HT": "Haiti",
  "HU": "Hungria",
  "ID": "Indonésia",
  "IE": "Irlanda",
  "IL": "Israel",
  "IM": "Ilha de Man",
  "IN": "Índia",
  "IO": "Território do Oceano Índico Britânico",
  "IQ": "Iraque",
  "IR": "Irã",
  "IS": "Islândia",
  "IT": "Itália",
  "JE": "Jersey",
  "JM": "Jamaica",
  "JO": "Jordânia",
  "JP": "Japão",
  "KE": "Quénia",
  "KG": "Quirguistão",
  "KH": "Camboja",
  "KI": "Kiribati",
  "KM": "Comores",
  "KN": "São Cristóvão e Nevis",
  "KP": "Coreia do Norte",
  "KR": "Coreia do Sul",
  "KW": "Kuwait",
  "KY": "Ilhas Cayman",
  "KZ": "Cazaquistão",
  "LA": "Laos",
  "LB": "Líbano",
  "LC": "Santa Lúcia",
  "LI": "Liechtenstein",
  "LK": "Sri Lanka",
  "LR": "Liberia",
  "LS": "Lesoto",
  "LT": "Lituânia",
  "LU": "Luxemburgo",
  "LV": "Letónia",
  "LY": "Líbia",
  "MA": "Marrocos",
  "MC": "Mónaco",
  "MD": "Moldávia",
  "ME": "Montenegro",
  "MF": "São Martinho (Parte Francesa)",
  "MG": "Madagáscar",
  "MH": "Ilhas Marshall",
  "MK": "Macedónia do Norte",
  "ML": "Mali",
  "MM": "Myanmar",
  "MN": "Mongólia",
  "MO": "Macau",
  "MP": "Ilhas Marianas do Norte",
  "MQ": "Martinica",
  "MR": "Mauritânia",
  "MS": "Montserrat",
  "MT": "Malta",
  "MU": "Maurícia",
  "MV": "Maldivas",
  "MW": "Malawi",
  "MX": "México",
  "MY": "Malásia",
  "MZ": "Moçambique",
  "NA": "Namíbia",
  "NC": "Nova Caledônia",
  "NE": "Níger",
  "NF": "Ilha Norfolk",
  "NG": "Nigéria",
  "NI": "Nicarágua",
  "NL": "Países Baixos",
  "NO": "Noruega",
  "NP": "Nepal",
  "NR": "Nauru",
  "NU": "Niue",
  "NZ": "Nova Zelândia",
  "OM": "Omã",
  "OS": "Ossétia do Sul",
  "PA": "Panamá",
  "PE": "Peru",
  "PF": "Polinésia Francesa",
  "PG": "Papua-Nova Guiné",
  "PH": "Filipinas",
  "PK": "Paquistão",
  "PL": "Polónia",
  "PM": "Saint-Pierre e Miquelon",
  "PN": "Ilhas Pitcairn",
  "PR": "Porto Rico",
  "PS": "Palestina",
  "PT": "Portugal",
  "PW": "Palau",
  "PY": "Paraguai",
  "QA": "Catar",
  "RE": "Reunião",
  "RO": "Romênia",
  "RS": "Sérvia",
  "RU": "Rússia",
  "RW": "Ruanda",
  "SA": "Arábia Saudita",
  "SB": "Ilhas Salomão",
  "SC": "Seychelles",
  "SD": "Sudão",
  "SE": "Suécia",
  "SG": "Singapura",
  "SH": "Santa Helena",
  "SI": "Eslovênia",
  "SJ": "Svalbard e Jan Mayen",
  "SK": "Eslováquia",
  "SL": "Serra Leoa",
  "SM": "San Marino",
  "SN": "Senegal",
  "SO": "Somália",
  "SR": "Suriname",
  "SS": "Sudão do Sul",
  "ST": "São Tomé e Príncipe",
  "SV": "El Salvador",
  "SX": "Sint Maarten",
  "SY": "Síria",
  "SZ": "Suazilândia",
  "TA": "Tristão da Cunha",
  "TC": "Turks e Caicos",
  "TD": "Chade",
  "TF": "Terras Austrais e Antárticas Francesas",
  "TG": "Togo",
  "TH": "Tailândia",
  "TJ": "Tajiquistão",
  "TK": "Tokelau",
  "TL": "Timor-Leste",
  "TM": "Turcomenistão",
  "TN": "Tunísia",
  "TO": "Tonga",
  "TR": "Turquia",
  "TT": "Trindade e Tobago",
  "TV": "Tuvalu",
  "TW": "Taiwan",
  "TZ": "Tanzânia",
  "UA": "Ucrânia",
  "UG": "Uganda",
  "UM": "Ilhas Menores Distantes dos Estados Unidos",
  "US": "Estados Unidos",
  "UY": "Uruguai",
  "UZ": "Uzbequistão",
  "VA": "Cidade do Vaticano",
  "VC": "São Vicente e Granadinas",
  "VE": "Venezuela",
  "VG": "Ilhas Virgens Britânicas",
  "VI": "Ilhas Virgens Americanas",
  "VN": "Vietnã",
  "VU": "Vanuatu",
  "WF": "Wallis e Futuna",
  "WS": "Samoa",
  "XK": "Kosovo",
  "YE": "Iêmen",
  "YT": "Mayotte",
  "ZA": "África do Sul",
  "ZM": "Zâmbia",
  "ZW": "Zimbábue",
  "ZZ": "Internacional"
}